import C2CVue from '../../libs/vue'
import $ from 'jquery'
import AOS from 'aos';

export default {
    name: 'base',

    // available hooks…
    beforeAppear() {
    },
    appear() {
        const done = this.async();

        setTimeout(() => {
            done();
        }, 100)

    },
    afterAppear() {

        const transitionDuration = parseFloat($('#data-transition').css('transition-duration')) * 1000;

        C2CVue.init();
        $('section.transition-wrapper').removeClass('close');
        $('section.transition-wrapper .logo-sprite-wrapper').fadeOut(100);
        AOS.init({
            once: true
        });

        setTimeout(() => {
            $('nav.main-menu').removeClass('hide-transition');
        }, transitionDuration);

    },
    beforeLeave({current, next, trigger}) {

        C2CVue.vueInstance.$destroy();
        $(window).trigger('beforeLeave', current.namespace);
        // $('html').addClass('no-scroll')
        $('nav.main-menu').addClass('hide-transition')

        $('section.slides-menu').addClass('hide-transition')

    },
    leave({current, next, trigger}) {

        const transitionDuration = parseFloat($('#data-transition').css('transition-duration')) * 1000;
        const loaderShowTime = 300;
        const done = this.async();
        $('section.transition-wrapper').addClass('close')
        let $lastSection = $(`section.rubrique-hp.init`);

        $lastSection.addClass('go-up');
        $lastSection.removeClass('init');

        setTimeout(() => {
            $('section.transition-wrapper .logo-sprite-wrapper').fadeIn(100);
        }, transitionDuration);

        setTimeout(() => {
            done();
        }, transitionDuration + loaderShowTime);

    },
    afterLeave() {
        // C2CVue.vueInstance.$destroy()
    },
    beforeEnter() {
        $('body')[0].classList.value = $('main')[1].classList.value;
        window.scrollTo(0, 0);
    },
    enter({current, next, trigger}) {
    },
    afterEnter() {
        const transitionDuration = parseFloat($('#data-transition').css('transition-duration')) * 1000;

        setTimeout(function () {
            C2CVue.init();
            $('section.transition-wrapper .logo-sprite-wrapper').fadeOut(100);
            $('section.transition-wrapper').removeClass('close');
            AOS.init({
                once: true
            });
        }, 100);

        setTimeout(() => {
            // $('html').removeClass('no-scroll')
            $('nav.main-menu').removeClass('hide-transition')
        }, transitionDuration);

    }
}